var _g, _g2, _g3, _g4, _g5, _g6, _path, _g7, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashKuang0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 140,
    viewBox: "0 0 97 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_2116_26)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2116_26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H89C93.4183 0 97 3.58172 97 8V132C97 136.418 93.4183 140 89 140H8C3.58172 140 0 136.418 0 132V8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H89C93.4183 0 97 3.58172 97 8V132C97 136.418 93.4183 140 89 140H8C3.58172 140 0 136.418 0 132V8Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1H89V-1H8V1ZM96 8V132H98V8H96ZM89 139H8V141H89V139ZM1 132V8H-1V132H1ZM8 139C4.13401 139 1 135.866 1 132H-1C-1 136.971 3.02944 141 8 141V139ZM96 132C96 135.866 92.866 139 89 139V141C93.9706 141 98 136.971 98 132H96ZM89 1C92.866 1 96 4.13401 96 8H98C98 3.02944 93.9706 -1 89 -1V1ZM8 -1C3.02944 -1 -1 3.02944 -1 8H1C1 4.13401 4.13401 1 8 1V-1Z",
    fill: "url(#paint0_linear_2116_26)",
    mask: "url(#path-1-inside-1_2116_26)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bii_2116_26)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_2116_26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 13C7 9.68629 9.68629 7 13 7H83C86.3137 7 89 9.68629 89 13V128C89 131.314 86.3137 134 83 134H13C9.68629 134 7 131.314 7 128V13Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13 8H83V6H13V8ZM88 13V128H90V13H88ZM83 133H13V135H83V133ZM8 128V13H6V128H8ZM13 133C10.2386 133 8 130.761 8 128H6C6 131.866 9.13401 135 13 135V133ZM88 128C88 130.761 85.7614 133 83 133V135C86.866 135 90 131.866 90 128H88ZM83 8C85.7614 8 88 10.2386 88 13H90C90 9.13401 86.866 6 83 6V8ZM13 6C9.13401 6 6 9.134 6 13H8C8 10.2386 10.2386 8 13 8V6Z",
    fill: "url(#paint1_linear_2116_26)",
    mask: "url(#path-3-inside-2_2116_26)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bii_2116_26)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51282 123H13.693C14.5285 123 15.2058 123.677 15.2058 124.513V128.693C15.2058 129.528 14.5285 130.206 13.693 130.206H9.51282C8.67731 130.206 8 129.528 8 128.693V124.513C8 123.677 8.67731 123 9.51282 123ZM9.51282 123.756H13.693C14.1107 123.756 14.4494 124.095 14.4494 124.513V128.693C14.4494 129.111 14.1107 129.449 13.693 129.449H9.51282C9.09507 129.449 8.75641 129.111 8.75641 128.693V124.513C8.75641 124.095 9.09507 123.756 9.51282 123.756Z",
    fill: "url(#paint2_linear_2116_26)",
    fillOpacity: 0.96
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bii_2116_26)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1353 127.14H17.3155C18.151 127.14 18.8283 127.818 18.8283 128.653V132.833C18.8283 133.669 18.151 134.346 17.3155 134.346H12.8965C12.1929 134.346 11.6225 133.776 11.6225 133.072V128.653C11.6225 127.818 12.2998 127.14 13.1353 127.14ZM13.1353 127.897H17.3155C17.7332 127.897 18.0719 128.235 18.0719 128.653V132.833C18.0719 133.251 17.7332 133.59 17.3155 133.59H12.8965C12.6106 133.59 12.3789 133.358 12.3789 133.072V128.653C12.3789 128.235 12.7176 127.897 13.1353 127.897Z",
    fill: "url(#paint3_linear_2116_26)",
    fillOpacity: 0.96
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bii_2116_26)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5813 130.206L86.6082 130.204C87.1612 130.164 87.5897 129.704 87.5897 129.15V124.513C87.5897 123.677 86.9124 123 86.0769 123H82.1353C81.2998 123 80.6225 123.677 80.6225 124.513V128.693C80.6225 129.528 81.2998 130.206 82.1353 130.206H86.5813ZM86.0769 123.756H82.1353C81.7176 123.756 81.3789 124.095 81.3789 124.513V128.693C81.3789 129.111 81.7176 129.449 82.1353 129.449H86.5544C86.7115 129.438 86.8333 129.307 86.8333 129.15V124.513C86.8333 124.095 86.4947 123.756 86.0769 123.756Z",
    fill: "url(#paint4_linear_2116_26)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bii_2116_26)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0701 134.346L83.089 134.345C83.7146 134.314 84.2058 133.798 84.2058 133.171V128.653C84.2058 127.818 83.5285 127.14 82.693 127.14H78.5128C77.6773 127.14 77 127.818 77 128.653V132.833C77 133.669 77.6773 134.346 78.5128 134.346H83.0701ZM82.693 127.897H78.5128C78.0951 127.897 77.7564 128.235 77.7564 128.653V132.833C77.7564 133.251 78.0951 133.59 78.5128 133.59H83.0512C83.2743 133.579 83.4494 133.394 83.4494 133.171V128.653C83.4494 128.235 83.1107 127.897 82.693 127.897Z",
    fill: "url(#paint5_linear_2116_26)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.8447 127H26.1553C24.9276 127 23.768 127.564 23.0096 128.529L14 140H83L73.9904 128.529C73.232 127.564 72.0724 127 70.8447 127Z",
    fill: "#FECE1E"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_2116_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7598 131.001V137H39.9482C41.7588 137 42.6333 135.893 42.6333 133.985C42.6333 132.087 41.772 131.001 39.9482 131.001H37.7598ZM38.9463 131.973H39.79C40.9766 131.973 41.4072 132.768 41.4072 134.007C41.4072 135.523 40.7876 136.029 39.79 136.029H38.9463V131.973ZM44.1187 137L44.5933 135.458H46.5928L47.063 137H48.3242L46.3247 131.001H44.9316L42.9189 137H44.1187ZM45.626 132.148L46.3555 134.574H44.8394L45.5732 132.148H45.626ZM48.6582 135.295C48.6758 136.13 49.2427 137.114 50.9829 137.114C52.4287 137.114 53.3604 136.411 53.3604 135.233C53.3604 134.161 52.6353 133.735 51.7476 133.542L50.8159 133.326C50.2754 133.208 49.9941 132.961 49.9941 132.601C49.9941 132.113 50.4028 131.81 51.04 131.81C51.7607 131.81 52.1167 132.21 52.1562 132.658H53.2725C53.2549 131.582 52.332 130.878 51.0444 130.878C49.8096 130.878 48.8076 131.524 48.8076 132.693C48.8076 133.7 49.5063 134.166 50.3281 134.35L51.2554 134.565C51.875 134.706 52.1782 134.921 52.1782 135.343C52.1782 135.84 51.7783 136.174 51.0488 136.174C50.2622 136.174 49.8447 135.761 49.8052 135.295H48.6582ZM59.2402 137V131.001H58.0493V133.44H55.5312V131.001H54.3447V137H55.5312V134.429H58.0493V137H59.2402Z",
    fill: "#623B00"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71 99.5C71 95.9101 73.9101 93 77.5 93H97V106H77.5C73.9101 106 71 103.09 71 99.5V99.5Z",
    fill: "#FDCC05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6621 101.85C73.709 103.098 74.7168 104.152 76.5332 104.152C78.3086 104.152 79.6094 103.039 79.6094 101.299C79.6094 99.6699 78.3789 98.6504 76.9785 98.6504C76.0469 98.6504 75.4434 99.0723 75.2617 99.3359H75.209L75.4082 97.2734H79.0234V95.9961H74.1426L73.7617 100.701H75.1504C75.332 100.309 75.7832 99.8516 76.5801 99.8516C77.4121 99.8516 78.0625 100.449 78.0625 101.369C78.0625 102.342 77.3066 102.904 76.5742 102.904C75.7891 102.904 75.2207 102.5 75.1211 101.85H73.6621ZM80.5527 100.279C80.5527 102.6 81.6133 104.152 83.5645 104.152C85.5801 104.152 86.6055 102.506 86.6055 100.279V99.7227C86.6055 97.3848 85.5508 95.8496 83.5938 95.8496C81.6484 95.8496 80.5527 97.3965 80.5527 99.7227V100.279ZM82.1289 99.7285C82.1289 98.0234 82.6973 97.1445 83.5762 97.1445C84.4609 97.1445 85.0234 98.0293 85.0234 99.7285V100.268C85.0234 101.973 84.4609 102.863 83.5762 102.863C82.6973 102.863 82.1289 101.979 82.1289 100.268V99.7285ZM89.0254 99.834C90.1035 99.834 90.7129 99.0371 90.7129 97.9414V97.666C90.7129 96.5352 90.0918 95.7793 89.0371 95.7793C87.9824 95.7793 87.3438 96.5352 87.3438 97.666V97.9414C87.3438 99.0723 87.9707 99.834 89.0254 99.834ZM89.0898 104L92.0547 100.104L95.2422 96.002H94.0234L91.1113 99.834L87.8711 104H89.0898ZM89.0312 98.8555C88.7266 98.8555 88.5273 98.5449 88.5273 97.9355V97.6719C88.5273 97.0684 88.7266 96.752 89.0312 96.752C89.3301 96.752 89.5293 97.0684 89.5293 97.6719V97.9355C89.5293 98.5449 89.3301 98.8555 89.0312 98.8555ZM94.0762 104.088C95.1602 104.088 95.7695 103.291 95.7695 102.195V101.92C95.7695 100.783 95.1484 100.033 94.0938 100.033C93.0391 100.033 92.4004 100.789 92.4004 101.92V102.195C92.4004 103.326 93.0273 104.088 94.0762 104.088ZM94.082 103.109C93.7832 103.109 93.584 102.799 93.584 102.189V101.926C93.584 101.322 93.7832 101.006 94.082 101.006C94.3867 101.006 94.5859 101.322 94.5859 101.926V102.189C94.5859 102.799 94.3867 103.109 94.082 103.109Z",
    fill: "#5D3800"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_2116_26",
    x: -20,
    y: -20,
    width: 137,
    height: 180,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2116_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2116_26",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.830521 0 0 0 0 0.605721 0 0 0 0 0.0194792 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2116_26"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.796078 0 0 0 0 0.27451 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2116_26",
    result: "effect3_innerShadow_2116_26"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bii_2116_26",
    x: -13,
    y: -13,
    width: 122,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2116_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2116_26",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.830521 0 0 0 0 0.605721 0 0 0 0 0.0194792 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2116_26"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.796078 0 0 0 0 0.27451 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2116_26",
    result: "effect3_innerShadow_2116_26"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bii_2116_26",
    x: -12,
    y: 103,
    width: 47.2058,
    height: 47.2058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2116_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2116_26",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.830521 0 0 0 0 0.605721 0 0 0 0 0.0194792 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2116_26"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.796078 0 0 0 0 0.27451 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2116_26",
    result: "effect3_innerShadow_2116_26"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bii_2116_26",
    x: -8.3775,
    y: 107.14,
    width: 47.2058,
    height: 47.2058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2116_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2116_26",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.830521 0 0 0 0 0.605721 0 0 0 0 0.0194792 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2116_26"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.796078 0 0 0 0 0.27451 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2116_26",
    result: "effect3_innerShadow_2116_26"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bii_2116_26",
    x: 60.6225,
    y: 103,
    width: 46.9672,
    height: 47.2058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2116_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2116_26",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.830521 0 0 0 0 0.605721 0 0 0 0 0.0194792 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2116_26"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.796078 0 0 0 0 0.27451 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2116_26",
    result: "effect3_innerShadow_2116_26"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bii_2116_26",
    x: 57,
    y: 107.14,
    width: 47.2058,
    height: 47.2058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2116_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2116_26",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.830521 0 0 0 0 0.605721 0 0 0 0 0.0194792 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2116_26"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.796078 0 0 0 0 0.27451 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2116_26",
    result: "effect3_innerShadow_2116_26"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_2116_26",
    x: 37.7598,
    y: 130.878,
    width: 22.4805,
    height: 7.23584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2116_26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2116_26",
    x1: 51,
    y1: 130.459,
    x2: -33.2653,
    y2: 67.2041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEB201",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEC1",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2116_26",
    x1: 51,
    y1: 124.902,
    x2: -28.596,
    y2: 74.3512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEB201",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEC1",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2116_26",
    x1: 14.4494,
    y1: 127.024,
    x2: 0.331961,
    y2: 123.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEB201",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEC1",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2116_26",
    x1: 18.0719,
    y1: 131.164,
    x2: 3.95446,
    y2: 127.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEB201",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEC1",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2116_26",
    x1: 71.3266,
    y1: 120.731,
    x2: 83.3616,
    y2: 128.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEC1",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEB201",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2116_26",
    x1: 69.8141,
    y1: 125.269,
    x2: 75.316,
    y2: 133.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEC1",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEB201",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashKuang0);
export default __webpack_public_path__ + "static/media/dash-kuang0.6f9e23afcf2c060f2ad8dea1c408b3ce.svg";
export { ForwardRef as ReactComponent };